/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type GetWalletsResponseEthItemMetadataType = typeof GetWalletsResponseEthItemMetadataType[keyof typeof GetWalletsResponseEthItemMetadataType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetWalletsResponseEthItemMetadataType = {
  digital: 'digital',
  jurisdiction: 'jurisdiction',
  commodity: 'commodity',
  securities: 'securities',
  insurance: 'insurance',
  alternative: 'alternative',
  commission: 'commission',
  operation: 'operation',
  subaccount: 'subaccount',
} as const;
